import { useTranslation } from 'react-i18next';
import getUserTypeTitle from '~myAccount/pages/AccountDetails/utils/getUserTypeTitle';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import { UserData } from '~/types/userTypes';

const UserType = () => {
  const { t } = useTranslation('app');
  const { data: response } = useGetUserQuery();
  const userTypeTitle = getUserTypeTitle(response?.user as UserData['user']);
  return (
    <div className="mt-2x">
      <label className="text-title_4 mb-1.5x block">{t('userType')}</label>

      <p className="text-body_2 text-gray__dark_2 px-1.5x py-x text-sm border border-gray rounded-[12px] bg-gray_light_1 mb-1.5x block">
        {userTypeTitle}
      </p>
      <p className="text-body_2 text-gray__dark_1 text-sm">
        {t('changeUserType')}
      </p>
    </div>
  );
};

export default UserType;
